import type { Register } from '../profile/register.ts';

export type TalkState = {
  dead: boolean;
  ready: boolean;
  opened: boolean;
  /**
   * `SessionEnded` has arrived and `ended` is waiting on a goodbye still
   * playing (`SessionProvider.serverEnded`). The microphone and barge-in are
   * already off, so nothing a press starts can be heard: the label says what
   * is happening rather than offering a conversation that has finished.
   */
  closing: boolean;
  holding: boolean;
  /**
   * The microphone is still opening for this press. Nothing it says is heard
   * yet, so the button does not say "listening" (media-channel design §4.4).
   */
  opening: boolean;
  autoCapturing: boolean;
  register: Register;
};

export type TalkLabel =
  | 'session-disconnected'
  | 'session-preparing-mic'
  | 'session-tutor-getting-ready'
  | 'session-saying-goodbye'
  | 'session-listening-kid'
  | 'session-listening-hold'
  | 'session-listening'
  | 'session-tap-to-talk'
  | 'session-hold-to-talk';

/**
 * The talk button's label. `closing` outranks `holding` because a press over
 * the goodbye still sets `holding`: the button is disabled by then, but a
 * press already under way when the goodbye was announced is not.
 */
export function talkLabel(s: TalkState): TalkLabel {
  if (s.dead) return 'session-disconnected';
  if (!s.ready) return 'session-preparing-mic';
  if (!s.opened) return 'session-tutor-getting-ready';
  if (s.closing) return 'session-saying-goodbye';
  if (s.holding && s.opening) return 'session-preparing-mic';
  if (s.holding) return s.register === 'kid' ? 'session-listening-kid' : 'session-listening-hold';
  if (s.autoCapturing) return 'session-listening';
  return s.register === 'kid' ? 'session-tap-to-talk' : 'session-hold-to-talk';
}
